export { default as GlobalQuickSearch } from './GlobalQuickSearch';
